import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import VisitorNavbar from "../component/VisitorNavbar";
import Footer from "../component/Footer";
import { baseurl, imageUrl } from "../Baseurl";
import logo from "../component/img/logo.png"; 
import { Filter, ShoppingCart } from "react-feather";
import noproduct from "../component/img/product_not_found.jpeg";
import { FaFilter } from "react-icons/fa";


const Searchs = () => {
  const { slug } = useParams();
  const [listingData, setListingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [menus, setMenus] = useState([]);
  const [checkedCategories, setCheckedCategories] = useState([]);
  const [categoryLevels, setCategoryLevels] = useState([]);

  // Fetch listing data
  const fetchListingData = async () => {
    try {
      const res = await axios.get(`${baseurl}getMainMenuBySlugNew/${slug}`);
      setListingData(res.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching listing data:", err);
      setError("Failed to load listings.");
      setLoading(false);
    }
  };

  // Fetch all menus
  const fetchMenus = async () => {
    try {
      const response = await axios.get(`${baseurl}getMenus`);
      const data = response.data;
      setMenus(data);

      const topLevel = data.filter(menu => menu.parent_id === null || menu.parent_id === 0);
      setCategoryLevels([{ level: 0, categories: topLevel }]);

      const slugMenu = data.find(menu => menu.slug === slug);
      if (slugMenu) {
        const hierarchy = [];
        let current = slugMenu;

        while (current) {
          hierarchy.unshift(current.id);
          current = data.find(m => m.id === current.parent_id);
        }

        setCheckedCategories(hierarchy);
        loadSubLevels(hierarchy, data);
      }
    } catch (error) {
      console.error("Error fetching menus:", error);
    }
  };

  const loadSubLevels = (selectedIds, allMenus) => {
    let levels = [];
    let parentId = null;

    selectedIds.forEach((id, idx) => {
      const options = allMenus.filter(menu => menu.parent_id === parentId);
      levels.push({ level: idx, categories: options });
      parentId = id;
    });

    const nextLevelOptions = allMenus.filter(menu => menu.parent_id === parentId);
    if (nextLevelOptions.length > 0) {
      levels.push({ level: levels.length, categories: nextLevelOptions });
    }

    setCategoryLevels(levels);
  };

  const handleCheckboxChange = (levelIndex, categoryId) => {
    const updatedChecked = [...checkedCategories.slice(0, levelIndex)];
    updatedChecked[levelIndex] = categoryId;

    setCheckedCategories(updatedChecked);
    loadSubLevels(updatedChecked, menus);
  };

  useEffect(() => {
    fetchListingData();
    fetchMenus();
  }, [slug]);








  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };






  return (
    <>
      <VisitorNavbar />
      <div className="container-fluid py-3">
        <div className="row g-2">
          <div className="col-md-3 hide-on-mobile">
            <div className="mnb1 text-start">
              <Filter /> Filter
            </div>

            <div className="filter-sidebar">
              {categoryLevels.map((level, index) => {
                const heading =
                  index === 0
                    ? "What we do"
                    : menus.find((m) => m.id === checkedCategories[index - 1])?.title || `Level ${index + 1}`;

                return (
                  <div key={index} className="mb-2">
                    <div className="d-block mb-1 mnb1 text-start">{heading}</div>
                    {level.categories.map((cat) => (
                      <div key={cat.id}>
                        <Link
                          to={cat.is_category ? `/shop/${cat.slug}` : `/searchs/${cat.slug}`}
                          className="form-check text-start text-dark"
                        >
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`cat-${cat.id}`}
                            checked={checkedCategories[index] === cat.id}
                            onChange={() => handleCheckboxChange(index, cat.id)}
                          />
                          <label htmlFor={`cat-${cat.id}`} className="form-check-label text-capitalize">
                            {cat.title}
                          </label>
                        </Link>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="col-md-9">
            <h4 className="product-desc-title text-capitalize">
              {slug
                .replace(/-\d+$/, (match) => (isNaN(match.slice(1)) ? match : ""))
                .replace(/-/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase())}
            </h4>

            {loading ? (
              <div className="d-flex justify-content-center align-items-center vh-50">
                <span className="loader"></span>
              </div>
            ) : error ? (
              <p className="text-danger">{error}</p>
            ) : (
              <div className="row g-1">
                {listingData.length > 0 ? (
                  listingData.map((product) => (
                    <div className="col-md-3 col-6" key={product.listing_id}>
                      <div className="product-card">
                      <img
  src={`${imageUrl}listing/${
    product.images?.find(
      (img) =>
        img &&
        /\.(jpg|jpeg|png|gif|webp)$/i.test(img)
    ) || noproduct
  }`}
  alt={product.title}
  className="img-fluid"
/>

                        {/* <div className="text-start">
                          <span className="cntn">{product.condition}</span>
                        </div> */}
<div className="p-2">
<h3 className="h6 mt-2">{product.title}</h3>
                        {product.type !== "quoteRequest" && (
  <div className="price mb-2">
    <span className="current-price">
      {convertPrice(product.price)}
    </span>
  </div>
)}

                        <Link to={`/product/${product.slug}`} className="btn add-to-cart">
                          <ShoppingCart size={16} /> &nbsp; View Details
                        </Link>
</div>

                        
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center">
                    <img src={noproduct} className="img-fluid noproductimg" alt="No Product Found" />
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>







      <button type="button" className="btn btn-primary cart-icon hide-on-desktop" data-bs-toggle="modal" data-bs-target="#exampleModal">
 Filter
</button>

<div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">Filters <Filter size={20} /></h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div className="modal-body">
      {/* <h4 className="product-desc-title">Filters <Filter size={20} /></h4> */}
             <div className="filter-sidebar">
              {categoryLevels.map((level, index) => {
                // Determine the heading for the current level 
                const heading =
                  index === 0
                    ? "What we do"
                    : menus.find((m) => m.id === checkedCategories[index - 1])?.title || `Level ${index + 1}`;
                    
                return (
                  <div key={index} className="mb-2">
                    <div className="d-block mb-1 mnb1 text-start">{heading}</div>
                    {level.categories.map((cat) => (
                      <div key={cat.id}>
                        <Link to={cat.is_category ? `/shop/${cat.slug}` : `/searchs/${cat.slug}`} className="form-check text-start text-dark ">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`cat-${cat.id}`}
                            checked={checkedCategories[index] === cat.id}
                            onChange={() => handleCheckboxChange(index, cat.id)}
                          />
                          <label htmlFor={`cat-${cat.id}`} className="form-check-label text-capitalize">
                            {cat.title}
                          </label>
                        </Link>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
      </div>
      <div className="modal-footer">
        {/* <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
        <button type="button" className="btn btn-primary" data-bs-dismiss="modal"> <FaFilter/> Filter</button>
      </div>
    </div>
  </div>
</div>







      <Footer />
    </>
  );
};

export default Searchs;
